import React from "react";
import PageLayout from "../components/PageLayout";
import { useTranslation } from "../i18n/LanguageContext";

function Organizers() {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t("organizers.title", "Organizer Accounts")}
      subtitle={t("organizers.subtitle", "Manage events, grow your community, and maximize attendance")}
    >
      <div className="space-y-8">
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("organizers.accountTitle", "🎯 What is an Organizer Account?")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "organizers.accountText",
              "An Organizer Account is designed for promoters, event agencies, and festival organizers to create, manage, and promote events directly to the PartyBuddy community."
            )}
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("organizers.featuresTitle", "Event Management Features")}
          </h2>
          <ul className="space-y-3 text-slate-300">
            {[
              ["createManage", "Create & Manage Events:", "Post detailed event information with images, descriptions, and ticketing details"],
              ["reach", "Reach New Audiences:", "Get your events in front of engaged event-seekers"],
              ["ticketing", "Integrated Ticketing:", "Sell tickets directly or link to external platforms"],
              ["community", "Community Building:", "Engage attendees before, during, and after events"],
              ["analytics", "Performance Analytics:", "Track attendance, interest trends, and audience growth"],
            ].map(([key, fallbackLabel, fallbackText]) => (
              <li key={key} className="flex gap-3">
                <span className="text-blue-400">→</span>
                <span>
                  <strong>{t(`organizers.features.${key}.label`, fallbackLabel)}</strong>{" "}
                  {t(`organizers.features.${key}.text`, fallbackText)}
                </span>
              </li>
            ))}
          </ul>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("organizers.perfectForTitle", "Perfect For")}
          </h2>
          <ul className="space-y-2 text-slate-300">
            {[
              ["festival", "🎭 Festival organizers and event series"],
              ["music", "🎵 Music promoters and booking agencies"],
              ["entertainment", "🎪 Entertainment companies"],
              ["party", "🎉 Party and club promoters"],
              ["cultural", "🎨 Cultural event organizers"],
            ].map(([key, fallback]) => (
              <li key={key}>{t(`organizers.perfectFor.${key}`, fallback)}</li>
            ))}
          </ul>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("organizers.becomeTitle", "Become an Organizer")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "organizers.becomeText1",
              "Organizer verification is currently in beta. Partners get access to advanced promotion tools and analytics."
            )}
          </p>
          <p className="text-slate-300">
            {t("organizers.becomeText2", "Want to grow your events on PartyBuddy? Reach out to")}{" "}
            <a
              href="mailto:organizers@partybuddy.app"
              className="text-blue-400 transition hover:text-blue-300"
            >
              organizers@partybuddy.app
            </a>
          </p>
        </section>
      </div>
    </PageLayout>
  );
}

export default Organizers;
